// Site configuration
export const SITE_NAME = "Juwa";
export const SITE_DESCRIPTION =
    "Free Social Casino for gamers - play slots, fish games, and card games, redeem cash prizes, 21+ only. No purchase necessary.";
export const SITE_LOGO = "/logo.png";
export const SITE_LOGO_CLASS = "rounded-xl"; // Rounded corners for logo
